import { BRACKET_REGEX } from '../../utils/constants';
import { initialState } from './state.customer';

// Actions
export const GET_CUSTOMER_DETAILS = 'GET_CUSTOMER_DETAILS';
export const UPDATE_CUSTOMER_DETAILS = 'UPDATE_CUSTOMER_DETAILS';
export const UPDATE_CUSTOMER_FIELD = 'UPDATE_CUSTOMER_FIELD';
export const SUBMIT_CUSTOMER_DETAILS = 'SUBMIT_CUSTOMER_DETAILS';
export const VALIDATE_CUSTOMER_DETAILS = 'VALIDATE_CUSTOMER_DETAILS';
export const RESET_ADDRESS_FIELDS = 'RESET_ADDRESS_FIELDS';
export const UPDATE_CUSTOMER_FINANCIAL_CHECK = 'UPDATE_CUSTOMER_FINANCIAL_CHECK';
export const CHECK_LINE_OF_CREDIT = 'CHECK_LINE_OF_CREDIT';

export const UpdateCustomStoreData = customer => {
  //update bank Reference with clabe field
  const { bankReference: { bankKey, accountNumber } = {} } = customer;
  customer.bankReference = {
    ...customer.bankReference,
    clabe: `${bankKey || ''}${accountNumber || ''}`
  };
  return customer;
};

// Reducer
export function customer(state, action) {
  if (!state) {
    state = initialState;
  }
  switch (action.type) {
    case GET_CUSTOMER_DETAILS: {
      const customer = UpdateCustomStoreData(handleNullInitial({ ...action.payload }, state));
      return { ...state, ...customer };
    }
    case UPDATE_CUSTOMER_DETAILS:
      return { ...state, ...UpdateCustomStoreData(action.payload) };
    case UPDATE_CUSTOMER_FINANCIAL_CHECK:
      return { ...state, customerOptoutAttachments: action.payload };
    case CHECK_LINE_OF_CREDIT:
      return { ...state, lineOfCredit: action.payload };
    case SUBMIT_CUSTOMER_DETAILS:
      return { ...state, ...action.payload };
    case UPDATE_CUSTOMER_FIELD: {
      const { name, value } = action.payload;
      return updatePropertyValue(state, name, value);
    }
    case VALIDATE_CUSTOMER_DETAILS:
      return { ...state, ...action.payload };
    case RESET_ADDRESS_FIELDS:
      return { ...state, ...clearAddressFields(action.payload, state) };
    default:
      return state;
  }
}

// Action Creators
export function getCustomer(payload) {
  return { type: GET_CUSTOMER_DETAILS, payload };
}

export function updateCustomer(payload) {
  return { type: UPDATE_CUSTOMER_DETAILS, payload };
}

export function updateCustomerFinancialCheck(payload) {
  return { type: UPDATE_CUSTOMER_FINANCIAL_CHECK, payload };
}

export function checkLineofCredit(payload) {
  return { type: CHECK_LINE_OF_CREDIT, payload };
}

export function updateField(payload) {
  return { type: UPDATE_CUSTOMER_FIELD, payload };
}

export function submitCustomer(payload) {
  return { type: SUBMIT_CUSTOMER_DETAILS, payload };
}

export function validateCustomer(payload) {
  return { type: VALIDATE_CUSTOMER_DETAILS, payload };
}

export function resetAddressFields(payload) {
  return { type: RESET_ADDRESS_FIELDS, payload };
}

// Data Helpers
function updateNestedValues(state, accumulator, names, value) {
  const name = names.shift();

  if (names.length === 0) {
    if (state) {
      if (name === 'country') {
        state.state = '';
      }
      state[name] = value;
    }
    return accumulator;
  }

  return updateNestedValues(state[name], { ...accumulator, ...state }, names, value);
}

export function updateValueInArray(state, match, name, value) {
  const names = name.split('.');
  const parentWithBracket = names.shift();
  const parent = parentWithBracket.split(BRACKET_REGEX)[0];
  const itemToUpdate = state[parent][match];
  let updatedItem;
  if (names.length > 1) {
    updatedItem = updateNestedValues(itemToUpdate, {}, names, value);
  } else {
    updatedItem = {
      ...itemToUpdate,
      [names]: value
    };
  }
  const parentArray = state[parent];
  parentArray.splice(match, 1, updatedItem);
  state[parent] = parentArray;
  return state;
}

export function updatePropertyValue(state, name, value) {
  const isArray = name.match(BRACKET_REGEX);
  if (isArray !== null) {
    return updateValueInArray(state, parseInt(isArray[1]), name, value);
  }
  const names = name.split('.');
  if (names.length > 1) {
    return updateNestedValues(state, {}, names, value);
  }
  return { ...state, [name]: value };
}

export function handleNullInitial(customer, state) {
  Object.keys(customer).forEach(key => {
    customer[key] = customer[key] || state[key];
  });
  return customer;
}

export function clearAddressFields(name, state) {
  const isArray = name.match(BRACKET_REGEX);
  let updatedState = state;
  if (isArray) {
    const fieldData = name
      // eslint-disable-next-line no-useless-escape
      .replace(/[\[\]']+/g, ',')
      .replace('.', '')
      .split(',');
    const [category, index, attribute] = fieldData;
    updatedState[category][index][attribute] = initialState.address;
    return updatedState;
  } else {
    const fieldData = name.split('.');
    const [category, attribute] = fieldData;
    updatedState[category][attribute] = initialState.address;
    return updatedState;
  }
}
